module.exports = __webpack_public_path__ + "42b6c0da974a7f5c890104ac15633981.svg";